import {
    SpacingToken,
    UiRadioGroup,
    UiStack,
} from '@experiences/ui-common';
import {
    ApDropdown,
    ApDropdownItem,
} from '@uipath/portal-shell-react';
import React from 'react';
import { useIntl } from 'react-intl';

import type { StepComponentProps } from '../../constants';
import { GovernancePolicyStepNavigation } from '../../subcomponent/GovernancePolicyStepNavigation';
import useGovernancePolicyCreateScopeStepViewModel from './GovernancePolicyCreateScopeStepViewModel';

export const GovernancePolicyCreateScopeStep: React.FC<StepComponentProps> = ({
    onNext,
    onBack,
}) => {
    const { formatMessage: translate } = useIntl();
    const viewModel = useGovernancePolicyCreateScopeStepViewModel({
        onNext,
        onBack,
    });

    return (
        <UiStack
            direction="column"
            justify="between"
            h="100%"
            data-cy="governance-policy-create-scope-step"
        >
            <UiStack
                direction="column"
                gap={SpacingToken.XS}
            >
                <UiRadioGroup
                    orientation="vertical"
                    label={translate({ id: 'CLIENT_GOVERNANCE_STEP_SCOPE_RADIO_GROUP_LABEL' })}
                    value={viewModel.selectedScope}
                    onChange={viewModel.handleScopeChange}
                    options={viewModel.scopeOptions}
                    data-cy="governance-scope-radio-group"
                />

                {viewModel.isTenantsSelected && (
                    <UiStack
                        direction="column"
                        gap={8}
                        ml={28}
                    >
                        <ApDropdown
                            style={{ maxWidth: '400px' }}
                            selectedValue={viewModel.selectedTenants}
                            multiple
                            onSelectedValueChanged={(event) => {
                                viewModel.handleTenantChange(event.detail);
                            }}
                            data-cy="governance-scope-tenant-dropdown"
                        >
                            {viewModel.tenants.map((tenant) => (
                                <ApDropdownItem
                                    key={tenant.id}
                                    value={tenant.id}
                                    label={tenant.name}
                                    data-cy={`governance-scope-tenant-item-${tenant.id}`}
                                />
                            ))}
                        </ApDropdown>
                    </UiStack>
                )}
            </UiStack>

            <GovernancePolicyStepNavigation
                onNext={viewModel.handleNext}
                onBack={viewModel.handleBack}
                backLabel={translate({ id: 'CLIENT_BACK' })}
                nextLabel={translate({ id: 'CLIENT_NEXT' })}
                disableNext={viewModel.isNextDisabled}
            />
        </UiStack>
    );
};
